import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listdevicepos',
  templateUrl: './listdevicepos.component.html',
  styleUrls: ['./listdevicepos.component.css']
})
export class ListdeviceposComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
